import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import TaskTracker from './pages/TaskTracker';
import BuildingProjects from './pages/BuildingProjects';
import BuildingManagement from './pages/BuildingManagement';
import Training from './pages/Training';
import UserManagement from './pages/UserManagement';
import MasterData from './pages/MasterData';
import CellStatus from './pages/CellStatus';
import TaskStatus from './pages/TaskStatus';
import QuarterStatus from './pages/QuarterStatus';
import OverallStatus from './pages/OverallStatus';
import TaskDetail from './pages/TaskDetail';
import RaciMatrix from './pages/RaciMatrix';
import DgDashboard from './pages/DgDashboard';
import Layout from './components/Layout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router basename='/projecttracker'>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="raci-matrix" element={<RaciMatrix />} />
                <Route path="dg-dashboard" element={<DgDashboard />} />
                <Route path="task-tracker" element={<TaskTracker />} />
                <Route path="task/:taskNo" element={<TaskDetail />} />
                <Route path="building-projects" element={<BuildingProjects />} />
                <Route path="building-management" element={<BuildingManagement />} />
                <Route path="training" element={<Training />} />
                <Route path="user-management" element={<UserManagement />} />
                <Route path="master-data" element={<MasterData />} />
                <Route path="cell-status" element={<CellStatus />} />
                <Route path="task-status" element={<TaskStatus />} />
                <Route path="quarter-status" element={<QuarterStatus />} />
                <Route path="overall-status" element={<OverallStatus />} />
              </Route>
            </Routes>
            <Toaster 
              position="top-center"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#10b981',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;

